import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useAnchor } from '$contexts/anchor';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleAnchor = ({ title, slug, parent }) => {
    const ref = useRef(null);
    const { setCurrent } = useAnchor();

    useEffect(() => {
        if (ref.current && typeof IntersectionObserver === 'function') {
            const handler = entries => {
                if (entries[0].isIntersecting) {
                    setCurrent(entries[0]?.target?.textContent);
                }
            };

            const observer = new IntersectionObserver(handler, {rootMargin: '0px 0px -80% 0px'});
            observer.observe(ref.current);

            return () => {
                observer.disconnect();
            };
        }
        return () => {};
    }, [ref.current]);

    return (
        <div className={`bg-white relative ${parent === 'FAQ' ? 'pb-20 pt-30 md:pb-40 md:pt-70' : 'pt-20 md:pt-30'} `}>
            <div className='layout-container'>
                <div
                    className='module-anchor sm:w-4/6 md:w-7/12 md:ml-w-4/12 px-10 sm:px-20'
                    id={slug}
                    ref={ref}>
                    <p className='type-style-2 md:type-style-3'>
                        {title}
                    </p>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleAnchor.propTypes = {
    slug: PropTypes.string,
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleAnchor;
